import { iconSizeOptions } from '../../../atoms/icons/icons-sizes'
import { Cancel } from '../../../atoms/icons/essentials'
import PropTypes from 'prop-types'

const AutocompleteClear = ({
  clearable,
  handleClickClear,
  disabled,
  readOnly
}) => {
  if (!clearable || disabled || readOnly) return null

  return (
    <Cancel
      size={iconSizeOptions['ICON-XS']}
      strokeWidth={3}
      onClick={handleClickClear}
      style={{ cursor: 'pointer' }}
    />
  )
}

AutocompleteClear.propTypes = {
  clearable: PropTypes.bool,
  handleClickClear: PropTypes.func,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool
}

export default AutocompleteClear
